import type { TimeFrame } from "@domains/engagement/shared/timeFrame.ts";
import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { ScopeSelector } from "@packages/core-client/scope/ScopeSelector.tsx";
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAnalyticsScopeClient } from "../api/query.ts";
import { useAnalyticsTracking } from "../hooks/useAnalyticsTracking.ts";
import { useFeedbackScope, useFeedbackTimeFrame } from "../hooks/useFeedbackFilters.ts";
import { EngagementPeriodToolbar } from "./EngagementPeriodToolbar.tsx";
import { FeedbackFilterBar } from "./FeedbackFilterBar.tsx";

export function FeedbackFiltersHeading() {
    const [scope, setScope] = useFeedbackScope();
    const [timeFrame, setTimeFrame] = useFeedbackTimeFrame();
    const scopeClient = useAnalyticsScopeClient();
    const { trackTimeRangeApplied } = useAnalyticsTracking();

    const { data: previews, isPending } = useQuery(createQueryOptions(scopeClient.getPreviews.queryOptions(), { throwOnError: false }));

    const handleTimeFrameChange = useCallback(
        (next: TimeFrame) => {
            void setTimeFrame(next);
            trackTimeRangeApplied(next);
        },
        [setTimeFrame, trackTimeRangeApplied]
    );

    return (
        <ScopeSelector
            scope={scope}
            onScopeChange={setScope}
            previews={previews}
            isPreviewsPending={isPending}
            trailingContent={
                <div className="flex flex-wrap items-center gap-2">
                    <EngagementPeriodToolbar timeFrame={timeFrame} onTimeFrameChange={handleTimeFrameChange} />
                    <FeedbackFilterBar />
                </div>
            }
        />
    );
}
